<template>
  <div :id="!print_mode ? 'title_' + link : null" class="title-all">
    <h1
      v-if="title_lv === 1"
      class="skinc-title1"
      :class="isFirstLv1 ? 'page-no-break-before' : 'page-break-before'"
      v-html="highlightedTitle"
    ></h1>

    <h2
      v-if="title_lv === 2"
      class="skinc-title2 page-no-break-after"
      v-html="highlightedTitle"
    ></h2>

    <h3 v-if="title_lv === 3" class="skinc-title3 page-no-break-after" style="color: #ee7501">
      {{ main_title }}
    </h3>

    <h4 v-if="title_lv === 5" class="skinc-title4 page-no-break-after">
      {{ main_title }}
    </h4>

    <h5
      v-if="title_lv === 4"
      class="skinc-title5 page-no-break-after"
      v-html="highlightedTitle"
    ></h5>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Title',
  props: {
    main_title: { type: String, default: '' },
    link: { type: String, default: '' },
    title_lv: { type: Number, default: 1 },
    print_mode: { type: Boolean, default: false },
    isFirstLv1: { type: Boolean, default: false },
    prevTitleLv: { type: Number, default: null }
  },
  mounted() {
    if (!this.print_mode) {
      this.setMarginForTitle();
    }
  },
  computed: {
    ...mapGetters('report_list', ['selected_report']),
    highlightedTitle() {
      if (!this.main_title) {
        return '';
      }

      if (this.title_lv === 1) {
        return this.main_title.replace(/`([^`]+)`/g, '<span style="color: #E1002A;">$1</span>');
      } else if (this.title_lv === 2) {
        return this.main_title.replace(
          /`([^`]+)`/g,
          `<span style="background-color: #EE7501; padding: 4px 12px; color: white; border-radius: 18px; font-weight: bold; font-size: 16px; line-height: 24px; margin-right: 12px;">$1</span>`
        );
      } else if (this.title_lv === 4) {
        return this.main_title.replace(
          /`([^`]+)`/g,
          `<span style="background-color: #EE7501; padding: 2px 8px; color: white; border-radius: 16px; font-weight: bold; font-size: 14px; line-height: 20px; margin-right: 8px;">$1</span>`
        );
      } else {
        return this.main_title;
      }
    }
  },
  methods: {
    setMarginForTitle() {
      const marginTop = '0';
      this.$el.style.marginTop = marginTop;
    }
  }
};
</script>

<style scoped>
.break-word {
  white-space: normal !important;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.title-all {
  display: flex;
  align-items: center;
}
</style>
